import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

export const BROWSER_TZ = (() => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch { return ""; } })();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vlog_token");
  config.headers = config.headers || {};
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (BROWSER_TZ) config.headers["X-Timezone"] = BROWSER_TZ;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 402 && typeof window !== "undefined") {
      const path = window.location.pathname;
      const onBilling = path.startsWith("/admin/billing");
      const isAdminArea = path.startsWith("/admin") || path.startsWith("/kiosk") || path.startsWith("/corporate");
      if (!onBilling && !path.startsWith("/login")) {
        if (isAdminArea && error.config?.url !== "/auth/me") {
          window.location.assign("/admin/billing?locked=1");
        } else if (!isAdminArea) {
          localStorage.removeItem("vlog_token");
          window.location.assign("/login?expired=1");
        }
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
